import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { ObjectSchema } from "yup";
import { ObjectShape } from "yup/lib/object";
import * as Yup from "yup";
import { UseFormProps } from "react-hook-form";
import { useLocation } from "react-router";
import { yupResolver } from "@/utils/yup";
import { createNewPassword } from "@/store/passwordRecovery/passwordRecoveryActions";
import SEO from "@/components/SEO";
import ResetPassword from "./ResetPassword";
import { ResetPasswordForm } from "./ResetPasswordForm";

const ResetPasswordContainer = () => {
  // TODO remove any type
  const { user_preference: userPreference } = useSelector((state: any) =>
    state.user.toJS()
  );

  const dispatch = useDispatch();

  const location = useLocation();

  const token = location.search?.replace("?token=", "");

  const language = userPreference?.language === "ESP" ? "/es" : "";

  const { t } = useTranslation(["translation.ResetPassword"]);

  const validationSchema: ObjectSchema<ObjectShape> = Yup.object().shape({
    password: Yup.string()
      .min(6, t("ValidatingPassword"))
      .required(t("Required")),
    confirm_password: Yup.string()
      .oneOf([Yup.ref("password")], t("PasswordDoesNotMatch"))
      .required(t("Required")),
  });

  const formOptions: UseFormProps = {
    // onBlur, onChange, and etc...
    mode: "all",
    resolver: yupResolver(validationSchema),
  };

  const { register, handleSubmit, formState } = useForm(formOptions);

  const { errors } = formState;

  const submit = (form: ResetPasswordForm) => {
    dispatch(createNewPassword(token, form.password));
  };

  return (
    <SEO title={t("ResetYourPassword")}>
      <ResetPassword
        onSubmit={submit}
        errors={errors}
        register={register}
        language={language}
        formHandleSubmit={handleSubmit}
      />
    </SEO>
  );
};

export default React.memo(ResetPasswordContainer);
